import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';


@Component({
  selector: 'lib-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LibNotificationComponent {

  get message(): string {
    return this.data.message ?? '';
  }

  get status(): 'error' | 'success' | 'warning' | 'info' {
    return this.data.status;
  }

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: {message: string, status: 'error' | 'success' | 'warning' | 'info'},
    protected _snack_bar_ref: MatSnackBarRef<LibNotificationComponent>
  ) {}

  close(): void {
    this._snack_bar_ref.dismiss();
  }

}
